export default "__VITE_ASSET__COn8SFb5__"